// extracted by mini-css-extract-plugin
export default {"errorContainer":"AgentChatContainer_errorContainer__HlVLe"};